export default __webpack_public_path__ + "static/media/ic-kyc-details.18a99b6c.svg";